module.exports = __webpack_public_path__ + "static/media/9.a704fce4.png";